import { Component } from "react";

class Base extends Component {
	subscriptions = [];
	
	componentWillUnmount() {
    if (this.subscriptions) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }
}

export default Base;